(function() {
    'use strict';
    angular
        .module('quantixApp')
        .controller('CompanyReportTeamDownloadController', CompanyReportTeamDownloadController);

    CompanyReportTeamDownloadController.$inject = ['$scope','$http','$timeout', '$state','CompanyReportService','$filter','$window','$uibModal'];

    function CompanyReportTeamDownloadController($scope,$http,$timeout, $state,CompanyReportService,$filter,$window,$uibModal) {
    	var teamDownloadModel = '';
		$scope.selectedUsers = []; 
        $scope.selectedCompanies = []; 
		$scope.fromDate = new Date();
		$scope.toDate = new Date();
		$scope.filter = {
			users : [],
			selectedCompanies : [],
			fromDate : new Date(),
			toDate : new Date()
		}
		$scope.usageTrackerGrid = '';
		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
				'shortDate', 'dd-MMM-yyyy' ];

		$scope.format = $scope.formats[0];
        $scope.requiredFormat = $scope.formats[4];
       
       	$scope.restFilter = function() {
			var d = new Date(); 
			d.setMonth(d.getMonth() - 6);
			$scope.filter.fromDate = d;
			$scope.filter.toDate = new Date();
		}
		$scope.restFilter();

		$scope.setData = function(response) {
			$scope.teamDownloadModel = {
				dataProvider : response,
				delegate : $scope
			};
		}

		$scope.popup3 = {
			opened : false
		};
		$scope.popup4 = {
			opened : false
		};
		$scope.open3 = function($event) {
			$scope.popup3.opened = true;
		};
		$scope.open4 = function($event) {
			$scope.popup4.opened = true;
		};

		$scope.getTeamDownloads = function() {
			CompanyReportService.getTeamDownloads().then(
				function(successData) {
					$scope.teamDownloadModel = {
                        dataProvider : successData,
                        delegate : $scope
                    };
					var users = _.uniqBy(successData, 'clientUserName');
					$scope.distinctUsers = [];
					for (var index = 0; index < users.length; index++) {
						const element = users[index];
						$scope.distinctUsers.push({
							'id': element.clientUserName,
							'name': element.clientUserName
						});
					}
					var companies = _.uniqBy(successData, 'companyCode');
					$scope.distinctCompanies = [];
					for (var index = 0; index < companies.length; index++) {
						const element = companies[index];
						$scope.distinctCompanies.push({
							'id': element.companyCode,
							'name': element.companyName
						});
					}
			}, function(errorData) {

			})
		}

		$scope.applyFiltersModal = function() {
			$uibModal.open({
				templateUrl: 'app/companyReport/customFilters/customTeamDownloadsFilter.html',
				size: 'md',
				scope: $scope,
				controller: 'CustomTeamDownloadsFilterController'
			})
		}

		$scope.getReportFormat = function(rowData) {
			var format = rowData.fileFormat.split(',');
			var returnTypes = '';
			for (var index = 0; index < format.length; index++) {
				const element = format[index];
				if(element.indexOf('.xlsx') >= 0) {
					returnTypes = returnTypes + '<svg onClick="openModal(\''+element+'\', \''+rowData.reportType+'\', \''+rowData.companyName+'\' , \''+rowData.downloadDate+'\', \''+rowData.userId+'\')" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="grid-svg" id="Capa_1" style="enable-background:new 0 0 128 128;" version="1.1" viewBox="0 0 128 128" xml:space="preserve"><style type="text/css">.st0{fill:#21A365;} .st1{fill:#107C41;} .st2{fill:#185B37;} .st3{fill:#33C481;} .st4{fill:#17864C;} .st5{fill:#FFFFFF;} .st6{fill:#036C70;} .st7{fill:#1A9BA1;} .st8{fill:#37C6D0;} .st9{fill:#04878B;} .st10{fill:#4F59CA;} .st11{fill:#7B82EA;} .st12{fill:#4C53BB;} .st13{fill:#0F78D5;} .st14{fill:#29A7EB;} .st15{fill:#0358A8;} .st16{fill:#0F79D6;} .st17{fill:#038387;} .st18{fill:#048A8E;} .st19{fill:#C8421D;} .st20{fill:#FF8F6A;} .st21{fill:#ED6B47;} .st22{fill:#891323;} .st23{fill:#AF2131;} .st24{fill:#C94E60;} .st25{fill:#E08195;} .st26{fill:#B42839;} .st27{fill:#0464B8;} .st28{fill:#0377D4;} .st29{fill:#4FD8FF;} .st30{fill:#1681D7;} .st31{fill:#0178D4;} .st32{fill:#042071;} .st33{fill:#168FDE;} .st34{fill:#CA64EA;} .st35{fill:#7E1FAF;} .st36{fill:#AE4BD5;} .st37{fill:#9332BF;} .st38{fill:#7719AA;} .st39{fill:#0078D4;} .st40{fill:#1490DF;} .st41{fill:#0364B8;} .st42{fill:#28A8EA;} .st43{fill:#41A5ED;} .st44{fill:#2C7BD5;} .st45{fill:#195ABE;} .st46{fill:#103E91;} .st47{fill:#2166C3;} .st48{opacity:0.2;}</style><rect class="st0" height="29.8" width="49.3" x="78.7" y="34.2"/><rect class="st1" height="29.8" width="49.3" x="78.7" y="64"/><rect class="st1" height="29.8" width="49.2" x="29.5" y="34.2"/><path class="st2" d="M78.7,93.8V64H29.6v29.8v4.3v19.6c0,3.2,2.6,5.8,5.8,5.8h86.7c3.2,0,5.8-2.6,5.8-5.8V93.8H78.7z"/><path class="st3" d="M122.1,4.5H78.6v29.8h49.4V10.3C127.9,7.1,125.3,4.5,122.1,4.5z"/><path class="st0" d="M78.7,4.5H35.5c-3.2,0-5.8,2.6-5.8,5.8v23.9h49.1V4.5z"/><path class="st4" d="M59.5,96.5h-53c-3.5,0-6.4-2.9-6.4-6.4V37.9c0-3.5,2.9-6.4,6.4-6.4h53c3.5,0,6.4,2.9,6.4,6.4v52.2  C65.9,93.6,63.1,96.5,59.5,96.5z"/><g><path class="st5" d="M40.5,82.4l-3.9-7.1c-1.6-2.8-2.6-4.7-3.7-6.8h-0.1c-0.9,2.1-1.8,4-3.3,6.8L26,82.4h-7.6l10.8-18.1L18.7,46.5   h7.7l3.9,7.4c1.2,2.2,2.1,4,3,6h0.2c1-2.2,1.7-3.8,2.9-6l3.9-7.4h7.6L37.2,64l11.1,18.4H40.5z"/></g><path class="st48" d="M66.7,37.3c0,0.2,0,0.4,0,0.6v52.2c0,3.5-2.9,6.4-6.4,6.4H30.4v5.7h35.2c3.5,0,6.4-2.9,6.4-6.4V43.6  C72.1,40.4,69.7,37.7,66.7,37.3z"/></svg>'
				} else if(element.indexOf('.docx') >= 0) {
					returnTypes = returnTypes + '<svg onClick="openModal(\''+element+'\', \''+rowData.reportType+'\', \''+rowData.companyName+'\', \''+rowData.downloadDate+'\', \''+rowData.userId+'\')" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="grid-svg" id="Capa_1" style="enable-background:new 0 0 128 128;" version="1.1" viewBox="0 0 128 128" xml:space="preserve"><style type="text/css">.st0{fill:#21A365;} .st1{fill:#107C41;} .st2{fill:#185B37;} .st3{fill:#33C481;} .st4{fill:#17864C;} .st5{fill:#FFFFFF;} .st6{fill:#036C70;} .st7{fill:#1A9BA1;} .st8{fill:#37C6D0;} .st9{fill:#04878B;} .st10{fill:#4F59CA;} .st11{fill:#7B82EA;} .st12{fill:#4C53BB;} .st13{fill:#0F78D5;} .st14{fill:#29A7EB;} .st15{fill:#0358A8;} .st16{fill:#0F79D6;} .st17{fill:#038387;} .st18{fill:#048A8E;} .st19{fill:#C8421D;} .st20{fill:#FF8F6A;} .st21{fill:#ED6B47;} .st22{fill:#891323;} .st23{fill:#AF2131;} .st24{fill:#C94E60;} .st25{fill:#E08195;} .st26{fill:#B42839;} .st27{fill:#0464B8;} .st28{fill:#0377D4;} .st29{fill:#4FD8FF;} .st30{fill:#1681D7;} .st31{fill:#0178D4;} .st32{fill:#042071;} .st33{fill:#168FDE;} .st34{fill:#CA64EA;} .st35{fill:#7E1FAF;} .st36{fill:#AE4BD5;} .st37{fill:#9332BF;} .st38{fill:#7719AA;} .st39{fill:#0078D4;} .st40{fill:#1490DF;} .st41{fill:#0364B8;} .st42{fill:#28A8EA;} .st43{fill:#41A5ED;} .st44{fill:#2C7BD5;} .st45{fill:#195ABE;} .st46{fill:#103E91;} .st47{fill:#2166C3;} .st48{opacity:0.2;}</style><path class="st43" d="M128,34.2H29.6V10.3c0-3.2,2.6-5.8,5.8-5.8h86.7c3.2,0,5.8,2.6,5.8,5.8V34.2z"/><rect class="st44" height="29.8" width="98.4" x="29.6" y="34.2"/><rect class="st45" height="29.8" width="98.4" x="29.6" y="64"/><path class="st46" d="M122.2,123.5H35.5c-3.2,0-5.8-2.6-5.8-5.8V93.8H128v23.9C128,120.9,125.4,123.5,122.2,123.5z"/><path class="st47" d="M59.5,96.5h-53c-3.5,0-6.4-2.9-6.4-6.4V37.9c0-3.5,2.9-6.4,6.4-6.4h53c3.5,0,6.4,2.9,6.4,6.4v52.2  C65.9,93.6,63.1,96.5,59.5,96.5z"/><g><path class="st5" d="M19.3,82.4l-8.9-35.9h7.1l3.5,16.3c0.9,4.4,1.8,8.9,2.4,12.5h0.1c0.6-3.8,1.6-8,2.6-12.6L30,46.5h7L40.6,63   c0.9,4.3,1.7,8.2,2.2,12.1h0.1c0.6-4,1.5-8,2.5-12.4l3.8-16.2h6.8l-9.8,35.9H39l-3.8-16.9c-0.9-4-1.6-7.4-2.1-11.3h-0.1   c-0.6,3.8-1.3,7.3-2.4,11.4l-4.2,16.9H19.3z"/></g><path class="st48" d="M65.9,37.3c0,0.2,0,0.4,0,0.6v52.2c0,3.5-2.9,6.4-6.4,6.4H29.7v5.7h35.2c3.5,0,6.4-2.9,6.4-6.4V43.6  C71.3,40.4,69,37.7,65.9,37.3z"/></svg>'
				} else {
					returnTypes = returnTypes + '<i onClick="openModal(\''+element+'\', \''+rowData.reportType+'\', \''+rowData.companyName+'\', \''+rowData.downloadDate+'\', \''+rowData.userId+'\')" class="fa fa-file-pdf-o pdf-icon grid-svg" aria-hidden="true"/>'
				}
			}
			return returnTypes;
		}
		var downloadDto = {};
		$window.openModal = function(reportName, reportType, companyName, downloadDate, userId) {
			
			downloadDto = {
				companyName: companyName,
				downloadDate: downloadDate,
				fileFormat: reportName,
				newData: "",
				reportType: reportType,
				userId: userId
			}
			console.log(downloadDto)
			$scope.message ={
				state: 'download',
				title: 'Report download',
				message: 'Would you like to re-download the report as generated on '+$filter('date')(downloadDto.downloadDate,'dd-MMM-yyyy')
			};
			$uibModal.open({
				templateUrl: 'app/companyReport/confirmationModals/confirmationmodal.html',
				size: 'sm',
				scope: $scope,
				controller: 'CustomFilterController'
			})
		}
		
		$scope.teamDownloadcreation  = function(event) {
			teamDownloadModel = event.target;
			teamDownloadModel.validateNow();
		}
		
		$scope.getDate = function(rowData, column) {
            return $filter('date')(rowData.downloadDate,'dd-MMM-yyyy');
		}
		
		$scope.getReportType = function(rowData, column) {
			return rowData.reportType+ $scope.getReportFormat(rowData);
		}
		
		$scope.getNewDataLabel = function(rowData, column) {
			return rowData.newData == 'No new data available' ? rowData.newData : rowData.newData + '<span class="load" onClick= "generateReport(this)"><i class="fa fa-download hover upload-fail grid-svg" title="Download New Report" ></i>';
		}
		
		$scope.downloadCompanyReportFromFiler = function() {
			$http({
				url : 'api/companyProfile/downloadcompanyreportfromfiler',
				method : 'POST',
				data: downloadDto,
				responseType : 'arraybuffer'
			})
			.success(
				function (response, status, headers, config) {
				
					if (downloadDto.fileFormat.indexOf('docx') > 0) {
							var isIE = false || !!document.documentMode;

					var blob = new Blob(
						[response], {
							type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

						});

					if (!isIE) {

						var anchor = angular.element('<a/>');
						var objectUrl = (window.URL || window.webkitURL)
							.createObjectURL(blob);
						anchor.css({
							display: 'none'
						});

						angular.element(document.body).append(
							anchor);
						// Attach to document

						anchor
							.attr({
								href: objectUrl,
								target: '_blank',
								download: 'Company_Report_for_' +
								downloadDto.companyName +
									'.doc'
							})[0].click();

						anchor.remove();
					} else {

						window.navigator
							.msSaveOrOpenBlob(
								blob,
								'Company_Report_for_' +
								downloadDto.companyName +
								'.doc');
					}
						} else if (downloadDto.fileFormat.indexOf('pdf') > 0) {
							var isIE = false || !!document.documentMode;
							$scope.response = response;
							var templateName = 'Company_Report_for_' + downloadDto.companyName + '.pdf';
							var blob = new Blob(
								[response],
								{
									type: 'application/pdf'
								});
							if (isIE) {
								window.navigator
									.msSaveOrOpenBlob(
										blob,
										'Company_Report_for_' + downloadDto.companyName + '.pdf');
							} else {
								var anchor = angular
									.element('<a/>');
								var blob = new Blob(
									[response],
									{
										type: 'application/pdf'
									})
								var objectUrl = (window.URL || window.webkitURL)
									.createObjectURL(blob);
								anchor.css({
									display: 'none'
								});
								angular.element(
									document.body)
									.append(anchor);
								anchor
									.attr({
										href: objectUrl,
										target: '_self',

										download: templateName
									})[0].click();

								anchor.remove();
				}
						} else {
							var templateName = 'Company_Report_for_' + downloadDto.companyName + '.xlsx';
							var isIE = false || !!document.documentMode;
							$scope.response = response;
							var blob = new Blob(
								[response],
								{
									type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
								});
							if (isIE) {
								window.navigator
									.msSaveOrOpenBlob(
										blob,
										templateName);
							} else {
								var anchor = angular
									.element('<a/>');
								var blob = new Blob(
									[response],
									{
										type: 'application/vnd.ms-excel'
									})
								var objectUrl = (window.URL || window.webkitURL)
									.createObjectURL(blob);
								anchor.css({
									display: 'none'
								});
								angular.element(
									document.body)
									.append(anchor);
								anchor
									.attr({
										href: objectUrl,
										target: '_self',

										download: templateName
									})[0].click();

								anchor.remove();
							}
						}
					

				}).error(
				function (response, status, headers, config) {
					vm.entityResponse = response;
					var decodedString = String.fromCharCode
						.apply(null, new Uint8Array(
							vm.entityResponse));
					var obj = JSON.parse(decodedString);
					$scope.error = true;
					$scope.errorMessage = " " + obj.message;
					$timeout(function () {
						$scope.error = false;
						$scope.errorMessage = "";

					}, 2000);
				})
		}
		$scope.getTeamDownloads();
    }
    })();
    	